import { FC } from 'react'
import Shipment from '../../../../../types/api/shipment'
import Floods from '../../../../../components/editable-cell/form-items/floods'
import VirtualStampFloods from '../../../../../components/editable-cell/form-items/virtual-stamp-floods'

interface ShipmentFloodsCellProps {
    record?: Shipment
}

/** Ручьи: при без высечки — virtualStamp.floods, иначе stampFloods (как в расчётах). */
const ShipmentFloodsCell: FC<ShipmentFloodsCellProps> = ({ record }) => {
    if (record?.withoutCutting) {
        return <VirtualStampFloods />
    }
    return <Floods />
}

export default ShipmentFloodsCell
